import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { FC, memo } from 'react'
import { TaskCategoryListToolbar } from './components/taskCategoryListToolbar/taskCategoryListToolbar'
import { TaskCategoryListGrid } from './components/taskCategoryListGrid/taskCategoryListGrid'

export const ProjectDetailManagementTaskCategoryList: FC = memo(() => {
  return (
    <div className="flex flex-col gap-2.5">
      <CrewErrorBoundary>
        <TaskCategoryListToolbar />
      </CrewErrorBoundary>

      <CrewErrorBoundary>
        <TaskCategoryListGrid />
      </CrewErrorBoundary>
    </div>
  )
})
